/**
 * Account-related Zod validation schemas
 * For account management operations (change email, delete account, etc.)
 */

import { z } from 'zod';
import { EmailSchema, PasswordSchema } from './common-schemas';

/**
 * Change Email Request Schema (FR102-FR106)
 * Validates email change requests from clients
 */
export const ChangeEmailRequestSchema = z.object({
  /** New email address (must be different from current) */
  newEmail: EmailSchema,
  /** Current password for verification */
  password: PasswordSchema,
});

/**
 * Type inference for ChangeEmailRequest
 */
export type ChangeEmailRequest = z.infer<typeof ChangeEmailRequestSchema>;
